import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import rocket from '../../assets/rocket.png';

import Parallax from '../layout/Parallax';

const useStyles = makeStyles((theme) => ({
    // [theme.breakpoints.up('xs')]: {}
    // [theme.breakpoints.up('sm')]: {}
    // [theme.breakpoints.up('md')]: {}
    // [theme.breakpoints.up('xl)]: {}
    root: {
        color: theme.palette.common.white
    },
    textWrapper: {
        marginBottom: theme.spacing(1),
        textAlign: 'center'
    },
    header: {
        fontWeight: 300
    },
    nanoMeet: {
        fontWeight: 700
    },
    underline: {
        fontSize: theme.typography.h6.fontSize
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
    textfield: {
        width: 300,
        color: theme.palette.common.white
    },
    image: {
        maxWidth: '100%',
        width: 300,
        display: 'block',
        margin: '0 auto'
    }
}))

export default function LearnMore(props) {
    const classes = useStyles();
    const button = document.getElementById("_form_42_submit");
    const [success, setSuccess] = useState(false)

    if (button) {
        button.addEventListener("click", () => {
            window.gtag('event', 'nanomeet_newsletter', {
                'event_callback': () => {
                    setSuccess(true);
                }
            })
        })
    }

    return (
        <Parallax>
            <div className={classes.root}>
                <div>
                    <img className={classes.image} src={rocket} />
                </div>
                <div className={classes.textWrapper}>
                    <Typography className={classes.header} variant="h4">
                        Learn more about <span className={classes.nanoMeet}>nanoMeet</span>
                    </Typography>
                    <Typography variant="body1" className={classes.underline}>
                        {success ? "We are looking forward to update you about our latest product news!" : "Stay up to date and sign up for nanocosmos news!"}
                    </Typography>
                </div>
                <div className={classes.wrapper}>
                    <div className={classes.form} className="_form_42"></div>
                </div>
            </div>
        </Parallax>
    )
}